import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	AdjustmentType: null as number | null,
	PartNo: '' as string | null,
	CreatedFrom: null as Date | null,
	CreatedTo: null as Date | null,
};
export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		PartReqReturnStatus: [],
		AdjustmentType: [],
	},
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		ReturnStatus: null as number | null,
		RejectedComments: '' as string,
		Remarks: null as string | null,
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
